import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginRegisterPage from "./LoginRegisterPage";
import MapPage from "./MapPage";
import ReportPage from "./ReportPage";
import ProtectedRoute from "./ProtectedRoute";  // مسیر صحیح را بررسی کن

function App() {
  return (
    <Router>
      <Routes>
        {/* صفحه لاگین همیشه باز است */}
        <Route path="/login" element={<LoginRegisterPage />} />

        {/* مسیرهای محافظت‌شده */}
        <Route element={<ProtectedRoute />}>
          <Route path="/map" element={<MapPage />} />
          <Route path="/reports" element={<ReportPage />} />
          <Route path="/reports" element={<ReportPage />} />
        </Route>

        {/* مسیر پیش‌فرض: کاربرانی که مسیر اشتباه وارد می‌کنند به لاگین هدایت شوند */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
